var ref;
/* eslint-disable indent */ export var CSS_DOMAIN = 'cloudcache.tencent-cloud.com';
// // 路由前缀
// import { runtime } from 'shared/i18n';
// import * as bucket from './bucket';
// import * as enviorment from './enviorment';
// import * as keycode from './keycode';
// export const ROUTE_BASE_PATH = '';
// // 根域名
// export const ROOT_DOMAIN = '.cloud.tencent.com';
// // 国际站域名
// export const QCLOUD_DOMAIN = `intl${ROOT_DOMAIN}`;
// // 官网域名
// export const CN_DOMAIN = 'cloud.tencent.com';
// // 控制台域名
// export const CONSOLE_DOMAIN = `console${ROOT_DOMAIN}`;
// // CDN 域名
export var CDN_DOMAIN = (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : ref.SSR) ? CSS_DOMAIN : window.__DOMAINS__ ? window.__DOMAINS__.CDN_DOMAIN : 'cloudcache.tencent-cloud.com';
// // 样式域名
// export const CSS_DOMAIN = CDN_DOMAIN;
// // cos CDN 域名
export var COS_CDN_DOMAIN = 'main.qcloudimg.com';
// // 账号安全设置页面
// export const ACCOUNT_SECURITY_SETTING_PAGE = `https://${CONSOLE_DOMAIN}/developer/security`;
// // 账号实名认证页面
// export const ACCOUNT_AUTH_PAGE = `https://${CONSOLE_DOMAIN}/developer/auth`;
// // 移动端实名认证页面
// export const ACCOUNT_AUTH_PAGE_M = `https://${ROOT_DOMAIN}/verify/identity`;
// // 微信分享 JD SDK 链接
// export const WECHAT_JS_SDK_CDN_URL = `https://${CDN_DOMAIN}/qcloud/main/scripts/release/common/deps/wechatJsSdk.js?version=1_0_1&max_age=31536000`;
// // 通用错误码
// export * from './service-errors';
// // 通用文档元信息
// export * from './meta';
// // 腾讯云防水墙App Id
export var T_CAPTCHA_ID = '2070586963';
// export const USER_LANGUAGE = runtime.language === 'jp' ? 'ja' : runtime.language;
// export { bucket, enviorment, keycode };
export var COUPON_STORAGE = 'coupon';
// 活动类型列表(10代金券/20折扣/30折扣加代金券/40自定义/50满返)
export var ACTIVITY_TYPE = {
    COUPON: '10',
    DISCOUNT: '20',
    DISCOUNT_AND_COUPON: '30',
    OTHER: '40',
    FULLBACK: '50'
};
// 合作伙伴登录后跳转
export var COMPANY_APPLY_URL = 'https://www.tencentcloud.com/account/partners/companyApplyInfo/index';
// 手机号验证页面
export var PHONE_VERIFY_URL = 'https://console.tencentcloud.com/developer/security';
// 手机号验证失败的错误码
export var PHONE_VERIFY_CODE = 900128;
// 领劵成功的接口返回码
export var VERIFY_SUCCESS_CODE = 0;
